module.exports = __webpack_public_path__ + "img/base_nature_panorama.dc5fbb21.svg";